import type { Auth0ProviderOptions } from '@auth0/auth0-react'

/**
 * Auth0 configuration for passwordless email authentication
 * Used for standalone flow (non-Epic flow)
 */
const getRedirectUri = (): string => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/login/callback`
  }
  // Fallback for SSR or initial load
  return '/login/callback'
}

const auth0Config = {
  domain: import.meta.env['VITE_AUTH0_DOMAIN'],
  clientId: import.meta.env['VITE_AUTH0_CLIENT_ID'],
  authorizationParams: {
    redirect_uri: getRedirectUri(),
    connection: 'email', // Passwordless email connection
    response_type: 'code',
    scope: 'openid profile email', // Silent authentication without refresh tokens
    audience: import.meta.env['VITE_AUTH0_AUDIENCE'], // ✅ Required for JWT tokens
  },
  useRefreshTokens: false, // Use silent authentication instead of refresh tokens
  cacheLocation: 'localstorage',
  // Bound silent auth. With localStorage caching a dead IdP session leaves stale
  // claims, so checkSession / getAccessTokenSilently fall back to a hidden
  // /authorize iframe that, by Auth0's default (~60s), hangs that long before
  // failing ("wce: Timeout"). That stranded deep-link users on the
  // "Loading client configuration..." / "Verifying order access..." overlays for
  // up to a minute before the guards could redirect to /login. A short bound makes
  // the no-session case resolve quickly so the route guards send the user to
  // /login almost immediately; a healthy session renews well within this window.
  authorizeTimeoutInSeconds: 5,
} satisfies Auth0ProviderOptions

export default auth0Config
